import assign = require('object-assign');
import {
    FETCH_MEASUREMENT_REQUEST, FETCH_MEASUREMENT_SUCCESS, FETCH_MEASUREMENT_FAILURE,
    FETCH_NODES_WITH_MEASUREMENTS_REQUEST, FETCH_NODES_WITH_MEASUREMENTS_SUCCESS, FETCH_NODES_WITH_MEASUREMENTS_FAILURE,
} from '../../constants/Node';

import { IWidgetDataState } from '../../interfaces/states';

const initialState = {};

export function isResponsible(action) {
    switch (action.type) {
        case FETCH_MEASUREMENT_REQUEST:
        case FETCH_MEASUREMENT_SUCCESS:
        case FETCH_MEASUREMENT_FAILURE:
        case FETCH_NODES_WITH_MEASUREMENTS_REQUEST:
        case FETCH_NODES_WITH_MEASUREMENTS_SUCCESS:
        case FETCH_NODES_WITH_MEASUREMENTS_FAILURE:
            return true;
        default:
            return false;
    }
}

function formatDate(measurement, key) {
    if (measurement[key]) {
        measurement[key] = new Date(measurement[key]);
    }
    return measurement;
}

function formatMeasurement(measurement) {
    formatDate(measurement, 'date');
    formatDate(measurement, 'lastDate');

    return measurement;
}

function formatMeasurements(measurements) {
    // if(Array.isArray(measurements)) {
    //     measurements.forEach(formatMeasurement);
    //     return measurements;
    // }

    // Object.keys(measurements).forEach(key => {
    //     measurements[key].forEach(formatMeasurement);
    // });

    return measurements;
}

export default function measurements(state = initialState, action): IWidgetDataState {
    switch (action.type) {
        case FETCH_NODES_WITH_MEASUREMENTS_REQUEST:
        case FETCH_MEASUREMENT_REQUEST: {
            return assign({}, state, {
                measurements: {
                    loading: true
                }
            });
        }
        case FETCH_NODES_WITH_MEASUREMENTS_SUCCESS: {
            return assign({}, state, {
                measurements: {
                    loading: false,
                    data: formatMeasurements(action.payload.measurements)
                }
            });
        }
        case FETCH_MEASUREMENT_SUCCESS: {
            return assign({}, state, {
                measurements: {
                    loading: false,
                    data: formatMeasurements(action.payload)
                }
            });
        }
        case FETCH_NODES_WITH_MEASUREMENTS_FAILURE:
        case FETCH_MEASUREMENT_FAILURE: {
            return assign({}, state, {
                measurements: {
                    loading: false,
                    error: action.error,
                    data: action.payload
                }
            });
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/widgetData/measurements.ts